const ContinuousLogoCarousel = {
  _selectors: {
    carousel: '.js-continuous-logo-carousel-animated-container'
  },

  _animationProportion: {
    speedInSeconds: 60,
    perItems: 8
  },

  init() {
    const self = this;

    // Sets animation duration on all carousels proportional to the settings in _animationProportion,
    // making all carousels move at the same speed regardless of how many items they have
    document.querySelectorAll(this._selectors.carousel).forEach(carouselEl => {
      const animationDurationInSeconds = self.getAnimationDurationForCurrentCarousel(carouselEl);
      carouselEl.style.animationDuration = animationDurationInSeconds + 's';

      // Useful so we can see the duration set on each carousel
      carouselEl.setAttribute('data-anim-duration', animationDurationInSeconds);
    });
  },

  getAnimationDurationForCurrentCarousel(carouselEl) {
    const speed = this._animationProportion.speedInSeconds;
    const perItems = this._animationProportion.perItems;

    // We need to divide it by 2 since we're doubling the amount of slides when rendering the carousel
    const totalItems = carouselEl.children.length / 2;

    // Formula to keep the same animation duration proportion
    return (speed * totalItems) / perItems;
  }
};

export default ContinuousLogoCarousel;
